import logoWhite from "@/assets/logo-white.webp";

type Props = { tone?: "white" | "ink"; compact?: boolean; locale?: "de" | "en" };

export function Logo({ tone = "white", compact = false, locale = "de" }: Props) {
  const alt = locale === "en" ? "Calvarius — Digital Agency" : "Calvarius — Digitalagentur";
  return (
    <span className="inline-flex items-center no-underline" aria-label={alt}>
      <img
        src={logoWhite}
        alt={alt}
        title={alt}
        width={288}
        height={224}
        decoding="async"
        className={`w-auto opacity-95 ${
          compact ? "h-9 md:h-12" : "h-14 md:h-[84px]"
        } ${tone === "ink" ? "invert" : ""}`}
      />
    </span>
  );
}
